import { z } from 'zod';
const base64url = z.string().min(16).max(256).regex(/^[A-Za-z0-9_-]+=*$/, 'base64url');
/** What the browser's PushSubscription.toJSON() gives (doc 28). */
export const PushSubscriptionSchema = z.object({
    endpoint: z.url().max(1024),
    keys: z.object({ p256dh: base64url, auth: base64url }),
});
export const PushEndpointSchema = z.object({ endpoint: z.url().max(1024) });
export const PushKeyResponseSchema = z.object({ publicKey: z.string() });
/** What the service worker receives. */
export const PushPayloadSchema = z.object({ title: z.string(), body: z.string(), url: z.string(), tag: z.string() });
//# sourceMappingURL=push.js.map